import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="mx-auto flex w-full max-w-[1280px] flex-col items-center px-4 py-24 text-center md:px-6">
      <p className="font-heading text-6xl font-extrabold tracking-tight text-primary-200 md:text-8xl">404</p>
      <h1 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
        页面走失了
      </h1>
      <p className="mt-2 max-w-md text-sm text-foreground-500">
        你访问的页面不存在或已被移除。当前路径：
        <span className="ml-1 font-mono text-foreground-700">{location.pathname}</span>
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
        <Link
          to="/"
          className="inline-flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-home-4-line text-lg" aria-hidden="true" />
          返回首页
        </Link>
        <Link
          to="/search"
          className="inline-flex h-11 cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-200 px-6 text-sm font-semibold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          <i className="ri-search-line text-lg" aria-hidden="true" />
          去搜索影视
        </Link>
      </div>
    </div>
  );
}